import * as ngCore from '@angular/core'

import * as state from '../../state'

/**
 * Injects everything from the {@link state} that needs to be injected
 * immediately so that associated effects can be registered immediately
 */
@ngCore.Injectable({ providedIn: 'root' })
export class EagerlyLoadedState {
  /** @see {@link state.me.Feature} */
  private readonly _meFeature = ngCore.inject(state.me.Feature)

  /** @see {@link state.display.toaster.Feature} */
  private readonly _toasterFeature = ngCore.inject(
    state.display.toaster.Feature,
  )
}
